import {useContext, useState} from 'react'

import Context from '@s-ui/react-context'

import SwitchHidePhone from './SwitchHidePhone.js'

export const useFormUserPersonalDataConfiguration = ({userData}) => {
  const {domain, i18n} = useContext(Context)
  const [formUserPersonalDataConfiguration, setFormUserPersonalDataConfiguration] = useState()

  const {
    formFieldIds: {
      email: emailFieldId,
      hidePhone: hidePhoneFieldId,
      lastName: lastNameFieldId,
      name: nameFieldId,
      phone: phoneFieldId,
      postalCode: postalCodeFieldId
    },
    formUserPersonalDataConfig: {fields: formUserPersonalDataConfigFields},
    numericFieldsToBeFormatted
  } = domain.get('config').get('form')

  const initFields = {
    [emailFieldId]: userData.email ?? '',
    [hidePhoneFieldId]: userData.hidePhone ?? 'false',
    [lastNameFieldId]: userData.lastName ?? '',
    [nameFieldId]: userData.name ?? '',
    [phoneFieldId]: userData.phone ?? '',
    [postalCodeFieldId]: userData.zipCode ?? ''
  }

  if (!formUserPersonalDataConfiguration) {
    setFormUserPersonalDataConfiguration(() => {
      const formFields = formUserPersonalDataConfigFields

      for (const field of formFields) {
        const {hint, label, help, constraints} = field
        if (hint) field.hint = i18n.t(hint, 1)
        if (label) field.label = i18n.t(label, 1)
        if (help) field.help = i18n.t(help, 1)
        if (constraints) {
          constraints.forEach(constraint => {
            if (constraint.message) constraint.message = i18n.t(constraint.message, 1)
          })
        }
      }

      return {
        form: {
          id: 'cochesnet-mt-form-user-personal-data',
          type: 'group',
          label: '',
          fields: [
            {
              id: 'userPersonalData',
              type: 'fieldset',
              display: 'block',
              hidden: false,
              fields: formFields
            }
          ]
        }
      }
    })
  }

  const SUIComponentsConfig = props => {
    const commonFieldProps = {size: 'l'}

    const fieldsConfig = {
      [emailFieldId]: {...commonFieldProps},
      [hidePhoneFieldId]: <SwitchHidePhone {...props} />,
      [lastNameFieldId]: {...commonFieldProps},
      [nameFieldId]: {...commonFieldProps},
      [phoneFieldId]: {...commonFieldProps},
      [postalCodeFieldId]: {...commonFieldProps}
    }

    return fieldsConfig[props.id]
  }

  return {
    formFieldIds: {
      name: nameFieldId,
      hidePhone: hidePhoneFieldId,
      lastName: lastNameFieldId,
      email: emailFieldId,
      phone: phoneFieldId,
      postalCode: postalCodeFieldId
    },
    formFields: formUserPersonalDataConfiguration && formUserPersonalDataConfiguration.form.fields,
    formUserPersonalDataConfiguration,
    initFields,
    numericFieldsToBeFormatted,
    SUIComponentsConfig
  }
}
